import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'modal-submit',
    templateUrl: './edl-modal-submit.component.html'
})
export class EdlModalSubmit {

    constructor(public activeModal: NgbActiveModal) {}
}